/**
 * Shared financial formatting utilities.
 *
 * Used by manager_income_financials_container and
 * renter_verified_financials_container so future changes apply to both views.
 */

export function formatCurrency(value?: number | null): string {
  if (value == null) return '—'
  return `$${value.toLocaleString('en-AU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`
}

export function formatPercentage(value?: number | null): string {
  if (value == null) return '—'
  return `${Math.round(value * 100)}%`
}

/**
 * Format an ISO 8601 date string to YYYY-MM-DD in UTC.
 *
 * Uses UTC getters so backend-emitted UTC timestamps render the same calendar
 * day regardless of the browser's local timezone. Returns null when the value
 * is absent or cannot be parsed as a valid date.
 */
export function formatISODate(value?: string | null): string | null {
  if (!value) return null
  const date = new Date(value)
  if (isNaN(date.getTime())) return null
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function formatNextPay(
  date?: string | null,
  amount?: number | null,
): string | null {
  if (amount == null && date == null) return null
  const formattedDate = formatISODate(date)
  if (amount != null && formattedDate != null)
    return `${formatCurrency(amount)} on ${formattedDate}`
  if (amount != null) return formatCurrency(amount)
  return formattedDate
}

export function getMissingEssentialsLabel(
  groceries?: boolean | null,
  transport?: boolean | null,
  accommodation?: boolean | null,
): string {
  const missing: string[] = []
  if (groceries) missing.push('Groceries')
  if (transport) missing.push('Transport')
  if (accommodation) missing.push('Accommodation')
  return missing.length > 0 ? missing.join(', ') : 'None'
}
